import { useStore } from "vuex";
import { computed } from "vue";
import { appLocalStorage } from "@utils/app.storage.ts";
import { Recipe } from "@plugins/recipe/types.ts";

export const DA_LAST_USED_RECIPE_KEY = "lastUsedRecipe";

const NUMBER_OF_RECIPE_CARDS_SHOWN = 3;

export function useRecipe() {
  const store = useStore();
  const userId = computed(() => store.getters["auth/userId"]);

  const getLastUsedRecipeId = (): unknown => {
    return JSON.parse(appLocalStorage.getItem(`${DA_LAST_USED_RECIPE_KEY}-${userId.value}`));
  };

  const getStartIndex = (recipes: Recipe[]): number => {
    if (recipes.length < NUMBER_OF_RECIPE_CARDS_SHOWN) {
      return 0;
    }

    const lastUsedRecipeId = getLastUsedRecipeId();

    if (typeof lastUsedRecipeId !== "number") {
      return 0;
    }

    const lastUsedIndex = recipes.findIndex((r) => r.id === lastUsedRecipeId);

    //if no lastUsedRecipe
    if (lastUsedIndex === -1) {
      return 0;
    } else if (recipes.length - lastUsedIndex <= 2) {
      //if last used recipe is one of the last 2 recipes in the list, return 3rd last index
      return recipes.length - NUMBER_OF_RECIPE_CARDS_SHOWN;
    } else {
      // if lastUsedRecipe is somewhere in the middle
      return lastUsedIndex;
    }
  };

  const sortRecipesByAlphabeticalOrder = (recipes: Recipe[]) => {
    return recipes.slice().sort((a, b) => a.title.localeCompare(b.title));
  };

  const setLastUsedRecipeToLocalStorage = (userId: number, recipeId: number | null) => {
    appLocalStorage.setItem(`${DA_LAST_USED_RECIPE_KEY}-${userId}`, recipeId);
  };

  return {
    getStartIndex,
    getLastUsedRecipeId,
    sortRecipesByAlphabeticalOrder,
    setLastUsedRecipeToLocalStorage,
  };
}
